import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Breadcrumb from '../../Breadcrumb/Breadcrumb';
import LoaderOverlay from '../../LoaderOverlay/LoaderOverlay';
import PanelSection from '../../FormElements/PanelSection';
import Popup from '../../Popups/Popup';
import PopupWithUseClickOutside from '../../Popups/PopupWithUseClickOutside';
import UserSelect from './UserSelect';
import FormSubmit from '../../FormElements/FormSubmit';
import GlobalErrorsBox from '../../ErrorComponents/GlobalErrorBox/GlobalErrorsBox';
import I18n from 'i18n-js';
import GroupBasicData from '../GroupData/GroupBasicData';
import EditGroupForm from '../GroupMgmt/EditGroupForm';
import DataTable2 from '../../DataTable2/DataTable2';
import Cell from '../../DataTable2/DataTableComponents/Cell';
import UserActionsMenuList from '../../UserActionsMenuList/UserActionsMenuList';

export default function GroupBuilder(props) {
	const { group_id } = useParams();
	const [
		loading,
		setLoading
	] = useState(true);
	const [
		popupLoading,
		setPopupLoading
	] = useState(false);
	const [
		isAddManagerPopupVisible,
		setIsAddManagerPopupVisible
	] = useState(false);
	const [
		isAddMemberPopupVisible,
		setIsAddMemberPopupVisible
	] = useState(false);
	const [
		isSuccessCardPopupVisible,
		setIsSuccessCardPopupVisible
	] = useState(false);
	const [
		isEditGroupFormPopupVisible,
		setIsEditGroupFormPopupVisible
	] = useState(false);
	const [
		isRemoveManagerCardPopupVisible,
		setIsRemoveManagerCardPopupVisible
	] = useState(false);
	const [
		isRemoveMemberCardPopupVisible,
		setIsRemoveMemberCardPopupVisible
	] = useState(false);
	const [
		isActionsMenuListVisible,
		setIsActionsMenuListVisible
	] = useState(false);
	const [
		error,
		setError
	] = useState(null);
	const [
		success,
		setSuccess
	] = useState(null);
	const [
		groupBasicDataSuccess,
		setGroupBasicDataSuccess
	] = useState(null);
	const [
		manager,
		setManager
	] = useState(null);
	const [
		managers,
		setManagers
	] = useState([]);
	const [
		member,
		setMember
	] = useState(null);
	const [
		members,
		setMembers
	] = useState([]);
	const [
		name,
		setName
	] = useState('');
	const [
		description,
		setDescription
	] = useState('');
	const [
		membersCount,
		setMembersCount
	] = useState(0);
	const [
		restrictionsCount,
		setRestrictionsCount
	] = useState(0);
	const [
		createdAt,
		setCreatedAt
	] = useState('');
	const [
		updatedAt,
		setUpdatedAt
	] = useState('');
	const [
		groupBasicData,
		setGroupBasicData
	] = useState(null);

	const onAddManager = (e) => {
		e.preventDefault();
		setPopupLoading(true);
		$.ajax({
			type: 'POST',
			url: props.iam_add_restriction_endpoint,
			data: {
				id: manager.id,
				group_id: group_id
			}
		}).done((data) => {
			// console.log("onAddManager done", data);
			setPopupLoading(false);
			if (data.status === 'success') {
				setManager(null);
				setSuccess(I18n.t('admin.group.success_adding_manager'));
				setIsAddManagerPopupVisible(false);
				setIsSuccessCardPopupVisible(true);

				// Call addManagers function to reload managers data
				addManagers();
			} else {
				setError(
					data && data.data && data.data.global && data.data.global.length
						? data.data.global[0]
						: I18n.t('admin.group.error_adding_manager')
				);
			}
		});
	};

	const onRemoveManager = (managerId) => {
		$.ajax({
			type: 'DELETE',
			url: props.iam_remove_restriction_endpoint,
			data: {
				id: managerId,
				group_id: group_id
			}
		}).done((data) => {
			// console.log('onRemoveManager done', data);
			if (data.status === 'success') {
				setSuccess(I18n.t('admin.success_removing_manager'));
				setIsRemoveManagerCardPopupVisible(false);
				setIsSuccessCardPopupVisible(true);

				// Call addManagers function to reload managers data
				addManagers();
			} else {
				setError(
					data && data.data && data.data.global && data.data.global.length
						? data.data.global[0]
						: I18n.t('admin.error_removing_manager')
				);
			}
		});
	};

	const onAddMember = (e) => {
		e.preventDefault();
		setPopupLoading(true);
		$.ajax({
			type: 'POST',
			url: props.iam_add_member_endpoint,
			data: {
				id: member.id,
				group_id: group_id
			}
		}).done((data) => {
			// console.log("onAddMember done", data);
			setPopupLoading(false);
			if (data.status === 'success') {
				setMember(null);
				setSuccess(I18n.t('admin.group.success_adding_member'));
				setIsAddMemberPopupVisible(false);
				setIsSuccessCardPopupVisible(true);

				// Call addMembers function to reload members data
				addMembers();
			} else {
				setSuccess(null);
				setError(
					data && data.data && data.data.global && data.data.global.length
						? data.data.global[0]
						: I18n.t('admin.group.error_adding_member')
				);
			}
		});
	};

	const onRemoveMember = (memberId) => {
		$.ajax({
			type: 'DELETE',
			url: props.iam_remove_member_endpoint,
			data: {
				id: memberId,
				group_id: group_id
			}
		}).done((data) => {
			// console.log('onRemoveMember done', data);
			if (data.status === 'success') {
				setSuccess(I18n.t('admin.success_removing_member'));
				setIsRemoveMemberCardPopupVisible(false);
				setIsSuccessCardPopupVisible(true);

				// Call addMembers function to reload members data
				addMembers();
			} else {
				setError(
					data && data.data && data.data.global && data.data.global.length
						? data.data.global[0]
						: I18n.t('admin.error_removing_member')
				);
			}
		});
	};

	const addManagers = () => {
		$.ajax({
			type: 'GET',
			url: props.iam_get_restrictions_endpoint,
			data: { id: group_id }
		}).done((data) => {
			// console.log('loadGroupRestrictions(Managers) done', data);
			setManagers(data.data);
		});
	};

	const addMembers = () => {
		$.ajax({
			type: 'GET',
			url: props.iam_get_members_endpoint,
			data: { id: group_id }
		}).done((data) => {
			// console.log('loadGroupMembers done', data);
			setMembers(data.data);
		});
	};

	const onChangeManager = (manager) => {
		setManager(manager);
	};

	const onChangeMember = (member) => {
		setMember(member);
	};

	const getName = (names, defaultName) => {
		console.log('getName', names, defaultName);
		const emailAddressPrincipal = names.find(
			(obj) => obj.type === 'EMAIL_ADDRESS_PRINCIPAL'
		);
		const emailAddress = names.find((obj) => obj.type === 'EMAIL_ADDRESS');
		const ssoPrincipal = names.find((obj) => obj.type === 'SSO_PRINCIPAL');

		return emailAddressPrincipal
			? emailAddressPrincipal.values[0]
			: ssoPrincipal
				? ssoPrincipal.values[0]
				: emailAddress ? emailAddress.values[0] : defaultName;
	};

	useEffect(
		() => {
			$.ajax({
				type: 'GET',
				url: props.iam_get_group_endpoint,
				data: { id: group_id }
			}).done((data) => {
				// console.log('loadGroup done', data);
				const {
					data: {
						name,
						description,
						membersCount,
						restrictionsCount,
						createdAt,
						updatedAt
					}
				} = data;
				setName(name);
				setDescription(description);
				setMembersCount(membersCount);
				setRestrictionsCount(restrictionsCount);
				setCreatedAt(new Date(createdAt));
				setUpdatedAt(updatedAt ? new Date(updatedAt) : null);
				setGroupBasicData(data);
				setLoading(false);
			});
		},
		[
			group_id
		]
	);

	useEffect(
		() => {
			$.ajax({
				type: 'GET',
				url: props.iam_get_restrictions_endpoint,
				data: { id: group_id }
			}).done((data) => {
				// console.log('loadGroupRestrictions(Managers) done', data);
				setManagers(data.data);
			});
		},
		[
			group_id
		]
	);

	useEffect(
		() => {
			$.ajax({
				type: 'GET',
				url: props.iam_get_members_endpoint,
				data: { id: group_id }
			}).done((data) => {
				// console.log('loadGroupMembers done', data);
				setMembers(data.data);
			});
		},
		[
			group_id
		]
	);

	if (loading) {
		return (
			<div style={{ position: 'relative' }}>
				<LoaderOverlay />
			</div>
		);
	}

	const userActionMenuStyles = {
		backgroundColor: 'white',
		padding: '8px',
		border: '1px solid #CED4DA',
		borderRadius: '5px',
		position: 'absolute',
		top: '0px',
		left: '0px',
		zIndex: '99',
		cursor: 'pointer'
	};

	return (
		<div className="GroupBuilder">
			<Breadcrumb
				category={I18n.t('admin.groups')}
				subcategory={name}
				pageName={I18n.t('admin.groups')}
			/>
			<div className="UserProfileCard card">
				<div className="card-body">
					<div className="row">
						<div className="col-12" style={{ position: 'relative' }}>
							<h1 className="username">{name}</h1>
							<h2 className="account-type">
								{I18n.t('admin.group.created_at')}: {createdAt.toLocaleString()}
								{updatedAt ? (
									<span>
										<span style={{ margin: '0 5px' }}>&ndash;</span>{' '}
										{I18n.t('admin.group.updated_at')}:{' '}
										{updatedAt.toLocaleString()}
									</span>
								) : null}
							</h2>
						</div>
					</div>
					<div className="row">
						<div className="col-12">
							<div className="UserPersonalInfo">
								<GroupBasicData
									title={I18n.t('admin.group.detail').toUpperCase()}
									groupBasicData={groupBasicData}
									onClickShowPopup={() => setIsEditGroupFormPopupVisible(true)}
								/>
							</div>
							<div className="UserPersonalInfo">
								<PanelSection
									title={I18n.t('admin.group.managers').toUpperCase()}
									hideEditLink={true}
									onClickAdd={() => setIsAddManagerPopupVisible(true)}
								>
									{/* Managers Data Table */}
									<div className="row">
										<div className="col-12 mx-2">
											<div
												className="jumbotron col-12 mt-4 mb-0 text-center"
												style={
													managers.length > 0 ? (
														{ display: 'none' }
													) : (
														{ backgroundColor: '#fff', textAlign: 'center' }
													)
												}
											>
												<div>{'No records found.'}</div>
											</div>
											{managers.length > 0 ? (
												<DataTable2
													// endpoint={this.props.iam_get_groups_endpoint}
													data={managers}
													// params={userParams}
													// sortOrder={this.state.sortOrder}
													// sortColumn={this.state.sortColumn}
													columns={[
														{
															displayName: 'Name',
															apiName: 'sortingName',
															colNum: 1,
															colWidth: 23,
															isSortable: false
														},
														{
															displayName: 'Created At',
															apiName: 'createdAt',
															colNum: 3,
															colWidth: 10,
															isSortable: false
														},
														{
															displayName: 'Updated At',
															apiName: 'updatedAt',
															colNum: 4,
															colWidth: 10,
															isSortable: false
														},
														{
															displayName: '',
															colNum: 5,
															colWidth: 10,
															isSortable: false
														}
													]}
													rowRenderer={(d) => {
														return (
															<tr key={d.id}>
																<td>
																	<Cell
																		value={getName(
																			d.summary.names,
																			d.summary.sortingName
																		)}
																	/>
																</td>
																<td>
																	<Cell
																		value={d.summary && d.summary.firstLoginAt}
																		type="date"
																	/>
																</td>
																<td>
																	<Cell
																		value={d.summary && d.summary.lastLoginAt}
																		type="date"
																	/>
																</td>
																<td>
																	<Cell
																		value={
																			<div
																				onClick={(e) => {
																					e.stopPropagation();
																					e.preventDefault();
																					// console.log('click', d);
																					onChangeManager(d);
																					setIsActionsMenuListVisible(d.id);
																				}}
																			>
																				<i
																					className="fa fa-ellipsis-h"
																					aria-hidden="true"
																				/>
																				<div style={{ position: 'relative' }}>
																					<UserActionsMenuList
																						style={userActionMenuStyles}
																						data={[
																							{
																								id: 1,
																								type: 'remove',
																								displayName: 'Remove',
																								action: (e) => {
																									e.stopPropagation();
																									e.preventDefault();
																									setIsActionsMenuListVisible(
																										false
																									);
																									setIsRemoveManagerCardPopupVisible(
																										true
																									);
																								}
																							}
																						]}
																						isMenuListVisible={
																							isActionsMenuListVisible === d.id
																						}
																						hideMenuList={() =>
																							setIsActionsMenuListVisible(
																								false
																							)}
																					/>
																				</div>
																			</div>
																		}
																	/>
																</td>
															</tr>
														);
													}}
													// onChange={this.onChange}
													// onChangeSortOrder={this.onChangeSortOrder}
													// isActionComplete={this.state.isActionComplete}
												/>
											) : null}
										</div>
									</div>
								</PanelSection>
							</div>
							<div className="UserPersonalInfo">
								<PanelSection
									title={I18n.t('admin.group.members').toUpperCase()}
									hideEditLink={true}
									onClickAdd={() => setIsAddMemberPopupVisible(true)}
								>
									{/* Members Data Table */}
									<div className="row">
										<div className="col-12 mx-2">
											<div
												className="jumbotron col-12 mt-4 mb-0 text-center"
												style={
													members.length > 0 ? (
														{ display: 'none' }
													) : (
														{ backgroundColor: '#fff', textAlign: 'center' }
													)
												}
											>
												<div>{'No records found.'}</div>
											</div>
											{members.length > 0 ? (
												<DataTable2
													// endpoint={this.props.iam_get_groups_endpoint}
													data={members}
													// params={userParams}
													// sortOrder={this.state.sortOrder}
													// sortColumn={this.state.sortColumn}
													columns={[
														{
															displayName: 'Name',
															apiName: 'sortingName',
															colNum: 1,
															colWidth: 23,
															isSortable: false
														},
														{
															displayName: 'Created At',
															apiName: 'createdAt',
															colNum: 3,
															colWidth: 10,
															isSortable: false
														},
														{
															displayName: 'Updated At',
															apiName: 'updatedAt',
															colNum: 4,
															colWidth: 10,
															isSortable: false
														},
														{
															displayName: '',
															colNum: 5,
															colWidth: 5,
															isSortable: false
														}
													]}
													rowRenderer={(d) => {
														return (
															<tr key={d.id}>
																<td>
																	<Cell
																		value={getName(
																			d.summary.names,
																			d.summary.sortingName
																		)}
																	/>
																</td>
																<td>
																	<Cell
																		value={d.summary && d.summary.firstLoginAt}
																		type="date"
																	/>
																</td>
																<td>
																	<Cell
																		value={d.summary && d.summary.lastLoginAt}
																		type="date"
																	/>
																</td>
																<td>
																	<Cell
																		value={
																			<div
																				onClick={(e) => {
																					e.stopPropagation();
																					e.preventDefault();
																					// console.log('click', d);
																					onChangeMember(d);
																					setIsActionsMenuListVisible(d.id);
																				}}
																			>
																				<i
																					className="fa fa-ellipsis-h"
																					aria-hidden="true"
																				/>
																				<div style={{ position: 'relative' }}>
																					<UserActionsMenuList
																						style={userActionMenuStyles}
																						data={[
																							{
																								id: 1,
																								type: 'remove',
																								displayName: 'Remove',
																								action: (e) => {
																									e.stopPropagation();
																									e.preventDefault();
																									setIsActionsMenuListVisible(
																										false
																									);
																									setIsRemoveMemberCardPopupVisible(
																										true
																									);
																								}
																							}
																						]}
																						isMenuListVisible={
																							isActionsMenuListVisible === d.id
																						}
																						hideMenuList={() =>
																							setIsActionsMenuListVisible(
																								false
																							)}
																					/>
																				</div>
																			</div>
																		}
																	/>
																</td>
															</tr>
														);
													}}
													// onChange={this.onChange}
													// onChangeSortOrder={this.onChangeSortOrder}
													// isActionComplete={this.state.isActionComplete}
												/>
											) : null}
										</div>
									</div>
								</PanelSection>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* Group Data Edit Popup */}
			<PopupWithUseClickOutside
				isPopupVisible={isEditGroupFormPopupVisible}
				onHidePopup={() => {
					setIsEditGroupFormPopupVisible(false);
					setSuccess(null);
					setError(null);
				}}
			>
				<Popup
					title={
						<h1 className="card-title">{I18n.t('admin.edit_group_title')}</h1>
					}
					onHidePopup={() => {
						setIsEditGroupFormPopupVisible(false);
						setSuccess(null);
						setError(null);
					}}
				>
					<EditGroupForm
						iam_get_group_endpoint={props.iam_get_group_endpoint}
						iam_update_group_endpoint={props.iam_update_group_endpoint}
						group_id={group_id}
						onHidePopup={() => {
							setIsEditGroupFormPopupVisible(false);
							setError(null);
						}}
						onShowSuccessCardPopup={() => {
							setIsSuccessCardPopupVisible(true);
						}}
						onActionCompleted={() => {
							setGroupBasicDataSuccess(I18n.t('admin.success_update_group'));
							$.ajax({
								type: 'GET',
								url: props.iam_get_group_endpoint,
								data: { id: group_id }
							}).done((data) => {
								// console.log('loadGroup done', data);
								const {
									data: { name, description, createdAt, updatedAt }
								} = data;
								setName(name);
								setDescription(description);
								setCreatedAt(new Date(createdAt));
								setUpdatedAt(updatedAt ? new Date(updatedAt) : null);
								setGroupBasicData(data);
							});
						}}
						isEditing={true}
					/>
				</Popup>
			</PopupWithUseClickOutside>

			{/* Group Manager Edit Popup */}
			<PopupWithUseClickOutside
				isPopupVisible={isAddManagerPopupVisible}
				onHidePopup={() => {
					setIsAddManagerPopupVisible(false);
					setManager(null);
					setSuccess(null);
					setError(null);
				}}
			>
				<Popup
					title={
						<h1 className="card-title">{I18n.t('admin.group.add_manager')}</h1>
					}
					onHidePopup={() => {
						setIsAddManagerPopupVisible(false);
						setManager(null);
						setSuccess(null);
						setError(null);
					}}
					body={groupBasicDataSuccess}
				>
					<form onSubmit={onAddManager}>
						{error ? (
							<GlobalErrorsBox
								globalErrors={[
									error
								]}
							/>
						) : null}
						<UserSelect
							endpoint={props.iam_users_remote_endpoint}
							onChange={onChangeManager}
						/>
						<div style={{ float: 'right', marginTop: 15, marginBottom: -15 }}>
							<FormSubmit text={I18n.t('admin.group.add_manager')} />
						</div>
					</form>
					{popupLoading ? <LoaderOverlay /> : null}
				</Popup>
			</PopupWithUseClickOutside>

			{/* Group Member Edit Popup */}
			<PopupWithUseClickOutside
				isPopupVisible={isAddMemberPopupVisible}
				onHidePopup={() => {
					setIsAddMemberPopupVisible(false);
					setMember(null);
					setSuccess(null);
					setError(null);
				}}
			>
				<Popup
					title={
						<h1 className="card-title">{I18n.t('admin.group.add_member')}</h1>
					}
					onHidePopup={() => {
						setIsAddMemberPopupVisible(false);
						setMember(null);
						setSuccess(null);
						setError(null);
					}}
				>
					<form onSubmit={onAddMember}>
						{error ? (
							<GlobalErrorsBox
								globalErrors={[
									error
								]}
							/>
						) : null}
						<UserSelect
							endpoint={props.iam_users_remote_endpoint}
							onChange={onChangeMember}
						/>
						<div style={{ float: 'right', marginTop: 15, marginBottom: -15 }}>
							<FormSubmit text={I18n.t('admin.group.add_member')} />
						</div>
					</form>
					{popupLoading ? <LoaderOverlay /> : null}
				</Popup>
			</PopupWithUseClickOutside>

			<PopupWithUseClickOutside
				isPopupVisible={isSuccessCardPopupVisible}
				onHidePopup={() => {
					setIsSuccessCardPopupVisible(false);
					setManager(null);
					setMember(null);
					setSuccess(null);
					setError(null);
				}}
			>
				<Popup
					title={
						<h1 className="card-title" style={{ color: 'green' }}>
							{I18n.t('success_card_title')}
						</h1>
					}
					body={success || groupBasicDataSuccess}
					onHidePopup={() => {
						setIsSuccessCardPopupVisible(false);
						setManager(null);
						setMember(null);
						setSuccess(null);
						setError(null);
					}}
				/>
			</PopupWithUseClickOutside>

			{/* Delete Manager (Restriction) Card Popup */}
			<PopupWithUseClickOutside
				isPopupVisible={isRemoveManagerCardPopupVisible}
				onHidePopup={() => {
					setIsRemoveManagerCardPopupVisible(false);
					setSuccess(null);
					setError(null);
				}}
			>
				<Popup
					title={
						<h1 className="card-title">
							{I18n.t('admin.remove_manager_title')}
						</h1>
					}
					body={
						<div>
							{manager ? (
								I18n.t('admin.remove_manager_body', {
									managerName: manager.summary.sortingName
								})
							) : (
								"Are you sure you want to remove this manager? This action can't be undone."
							)}
							<div style={{ float: 'right' }} className="mt-4">
								<button
									className="btn btn-secondary mx-2"
									onClick={() => {
										setIsRemoveManagerCardPopupVisible(false);
									}}
								>
									No, cancel
								</button>
								<button
									className="btn btn-primary"
									onClick={() => {
										onRemoveManager(manager.id);
									}}
								>
									Yes, delete
								</button>
							</div>
						</div>
					}
					onHidePopup={() => {
						setIsRemoveManagerCardPopupVisible(false);
					}}
				/>
			</PopupWithUseClickOutside>

			{/* Delete Member Card Popup */}
			<PopupWithUseClickOutside
				isPopupVisible={isRemoveMemberCardPopupVisible}
				onHidePopup={() => {
					setIsRemoveMemberCardPopupVisible(false);
					setSuccess(null);
					setError(null);
				}}
			>
				<Popup
					title={
						<h1 className="card-title">
							{I18n.t('admin.remove_manager_title')}
						</h1>
					}
					body={
						<div>
							{member ? (
								I18n.t('admin.remove_member_body', {
									memberName: member.summary.sortingName
								})
							) : (
								"Are you sure you want to remove this member? This action can't be undone."
							)}
							<div style={{ float: 'right' }} className="mt-4">
								<button
									className="btn btn-secondary mx-2"
									onClick={() => {
										setIsRemoveMemberCardPopupVisible(false);
									}}
								>
									No, cancel
								</button>
								<button
									className="btn btn-primary"
									onClick={() => {
										onRemoveMember(member.id);
									}}
								>
									Yes, delete
								</button>
							</div>
						</div>
					}
					onHidePopup={() => {
						setIsRemoveMemberCardPopupVisible(false);
					}}
				/>
			</PopupWithUseClickOutside>
		</div>
	);
}
